import React, { useCallback, useEffect, useState } from 'react';
import { Button, Stack, TextField } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchOrganizationsRequest,
  markOrganizationCreated,
  markOrganizationEdited,
} from '../../api/organizations/organizationSlice';
import { useNavigate } from 'react-router-dom';
import { selectUser } from '../../api/auth/authSlice';
import { DataGrid } from '@mui/x-data-grid';
import { debounce } from 'lodash';

const OrganizationTable = () => {
  const dispatch = useDispatch();
  const { organizations, totalCount } = useSelector((state) => state.organizations);
  const [page] = useState(0);
  const [limit] = useState(10);
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState('');
  let user = useSelector(selectUser);

  useEffect(() => {
    dispatch(markOrganizationCreated(false));
    dispatch(markOrganizationEdited(false));
    dispatch(fetchOrganizationsRequest({ page: page + 1, limit: limit }));
  }, [dispatch, page, limit]);

  const handleEdit = (id) => {
    navigate(`/organizations/edit/${id}`);
  };

  const handleSearchChange = useCallback(
    debounce((e) => {
      setSearchValue(e.target.value);
      dispatch(
        fetchOrganizationsRequest({
          page: 1,
          limit: 10,
          email: e.target.value,
        }),
      );
    }, 500), // Adjust debounce delay as needed (500ms)
    [dispatch],
  );

  const columns = [
    {
      field: 'name',
      headerName: 'Name',
      flex: 1,
    },
    {
      field: 'email',
      headerName: 'Email',
      flex: 1,
    },
    {
      field: 'contact_emails',
      headerName: 'Contact Emails',
      flex: 1,
      valueGetter: (params) => {
        return Array.isArray(params) ? params.join(', ') : '';
      },
    },
    {
      field: 'stripe_customer_id',
      headerName: 'Stripe Customer ID',
      flex: 1,
    },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 0.5,
      sortable: false,
      renderCell: (params) => (
        <Button variant="outlined" color="primary" size="small" onClick={() => handleEdit(params.row._id)}>
          Edit
        </Button>
      ),
    },
  ];

  return (
    <>
      <Stack
        sx={{
          justifyContent: 'flex-end',
          alignItems: 'end',
          mb: 1,
        }}
      >
        <TextField
          size={'small'}
          id={'search-email'}
          label="Search by email"
          variant="outlined"
          onChange={handleSearchChange}
        />
      </Stack>
      <DataGrid
        rows={organizations}
        columns={columns}
        getRowId={(row) => row._id}
        paginationMode="server"
        rowCount={totalCount}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: limit,
            },
          },
        }}
        pageSizeOptions={[10, 25]}
        disableRowSelectionOnClick
        onPaginationModelChange={(model) => {
          dispatch(
            fetchOrganizationsRequest({
              page: model.page + 1,
              limit: model.pageSize,
              email: searchValue,
            }),
          );
        }}
      />
    </>
  );
};

export default OrganizationTable;
